import { render, staticRenderFns } from "./techtree.vue?vue&type=template&id=5aa67938"
import script from "./techtree.vue?vue&type=script&lang=js"
export * from "./techtree.vue?vue&type=script&lang=js"
import style0 from "./techtree.vue?vue&type=style&index=0&id=5aa67938&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports